import React, {useEffect, useState} from 'react';
import {Text, View, Row} from '@unthinkable/react-core-components';
import {ActivityIndicator} from '@unthinkable/react-activity-indicator';

import {
  PerformersContainer,
  PerformerTableStyle,
  PerformerTaskCardStyle,
} from '../styles/PerformersTable.style';
import {TogglerContainer, TogglerTab} from '../styles/Dashboard.style';
import {HttpAuthService} from 'src/services';
import {routeLink} from 'src/constant';
import {useAuth} from 'src/modules/auth/hooks/useAuth';
import {STATS_TYPE} from 'src/constant/stats';
import {useToast} from '@unthinkable/react-toast';

export const PerformanceTable = ({sort}) => {
  const {user} = useAuth();
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(STATS_TYPE.tcmCompletionRatio);
  const [data, setData] = useState([]);
  const toast = useToast();
  const handleToggle = tab => {
    setActive(tab);
  };
  const getData = async () => {
    try {
      setLoading(true);
      let currentMonth = new Date().getMonth() + 1;
      let lastMonth = currentMonth - 1;
      let lastYear = new Date().getFullYear();
      const filter = {
        type: STATS_TYPE[active],
        month: lastMonth,
        year: lastYear,
        date: {$exists: false},
      };
      const fields = {
        [STATS_TYPE[active]]: 1,
      };
      if (user?.practiceId?._id) {
        filter.scope = 'facility';
        filter.practiceId = user?.practiceId?._id;
        fields['facilityId'] = {
          name: 1,
        };
      } else {
        filter.scope = 'practice';
        fields['practiceId'] = {
          name: 1,
        };
      }

      if (lastMonth <= 0) {
        lastMonth = 12;
        lastYear--;
      }
      const response = await HttpAuthService.get(routeLink.getStats, {
        params: {
          filter: JSON.stringify(filter),
          fields: fields,
          sort: {
            [STATS_TYPE[active]]: sort,
          },
        },
      });
      setData(response.data);
    } catch (err) {
      console.error(err.message || err);
      toast({
        type: 'Error',
        message: `${err?.message || err || ''}`,
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getData();
  }, [active, sort]);

  const renderTaskCard = ({row, index}) => {
    const borderColor = index % 2 !== 0 ? '#4EA875' : '#ff9d2b';

    return (
      <Row style={{...PerformerTaskCardStyle.container, borderColor}}>
        <Text style={PerformerTaskCardStyle.Heading}>
          {row?.facilityId?.name || row?.practiceId?.name}
        </Text>
        <Text style={PerformerTaskCardStyle.SubHeading}>
          {row[STATS_TYPE[active]]}%
        </Text>
      </Row>
    );
  };

  return (
    <View style={PerformerTableStyle}>
      <TogglerContainer key={'toggler'}>
        <TogglerTab
          active={active === STATS_TYPE.tcmCompletionRatio}
          onClick={() => handleToggle(STATS_TYPE.tcmCompletionRatio)}
          first={true}>
          TCM <br /> Completion
        </TogglerTab>
        <TogglerTab
          active={active === STATS_TYPE.reAdmission}
          onClick={() => handleToggle(STATS_TYPE.reAdmission)}>
          Readmission <br /> Rate
        </TogglerTab>
        <TogglerTab
          active={active === STATS_TYPE.currentHospitalization}
          onClick={() => handleToggle(STATS_TYPE.currentHospitalization)}
          last={true}>
          Hospitalization <br /> Rate
        </TogglerTab>
      </TogglerContainer>

      <PerformersContainer>
        {loading && <ActivityIndicator />}
        {!loading && !data.length && <div>No Data Found</div>}
        {!loading &&
          data.map((element, index) => renderTaskCard({row: element, index}))}
      </PerformersContainer>
    </View>
  );
};
